const SET_LANGUAGE = '@language/set-language';

export {SET_LANGUAGE};